import React from "react";
import { useTranslation } from "react-i18next";
import { Chip } from "@outpave/ds";
import type { ChipTone } from "@outpave/ds";
import AccountStatus from "enums/AccountStatus";

// Not RenderAccountStatus: different vocabulary.
// SUBMITTED cannot appear until PR #1144. See README.md.
const STATUS_TONES: Record<string, { tone: ChipTone; label: string }> = {
  [AccountStatus.ACTIVE]: { tone: "positive", label: "Active" },
  [AccountStatus.SUBMITTED]: { tone: "warning", label: "Pending" },
  [AccountStatus.DISCONNECTED]: { tone: "negative", label: "Disconnected" },
  [AccountStatus.INACTIVE]: { tone: "neutral", label: "Inactive" },
  [AccountStatus.REQUESTED]: {
    tone: "neutral",
    label: "Pending Authorization",
  },
};

export interface ConnectionStatusBadgeProps {
  status: AccountStatus;
  /** Prefix the label with a tone-coloured dot. */
  showDot?: boolean;
}

const ConnectionStatusBadge: React.FC<ConnectionStatusBadgeProps> = ({
  status,
  showDot = true,
}) => {
  const { t } = useTranslation();
  const mapped = STATUS_TONES[status];

  if (!mapped) {
    return (
      <Chip tone="neutral" size="sm" dot={showDot}>
        {status}
      </Chip>
    );
  }

  return (
    <Chip tone={mapped.tone} size="sm" dot={showDot}>
      {t(mapped.label)}
    </Chip>
  );
};

export default ConnectionStatusBadge;
